var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.564 9.04116L9.86956 5.40477C9.7709 5.30807 9.63826 5.2539 9.50011 5.2539C9.36196 5.2539 9.22932 5.30807 9.13067 5.40477L5.43622 9.04116C5.33614 9.13914 5.27908 9.27287 5.2776 9.41292C5.27611 9.55297 5.33032 9.68788 5.42831 9.78796C5.52629 9.88805 5.66002 9.94511 5.80007 9.94659C5.94012 9.94808 6.07503 9.89386 6.17511 9.79588L8.97233 7.04616V16.8892C8.97233 17.0292 9.02794 17.1634 9.12692 17.2624C9.22589 17.3614 9.36014 17.417 9.50011 17.417C9.64009 17.417 9.77433 17.3614 9.87331 17.2624C9.97228 17.1634 10.0279 17.0292 10.0279 16.8892L10.0279 7.04616L12.8251 9.79588C12.9252 9.89386 13.0601 9.94808 13.2002 9.94659C13.3402 9.94511 13.4739 9.88805 13.5719 9.78796C13.6699 9.68788 13.7241 9.55297 13.7226 9.41292C13.7211 9.27287 13.6641 9.13914 13.564 9.04116Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16678 13.1949C1.70936 13.1949 0.527886 14.3763 0.527886 15.8338C0.527886 17.2912 1.70936 18.4727 3.16678 18.4727C4.62419 18.4727 5.80566 17.2912 5.80566 15.8338C5.80566 14.3763 4.62419 13.1949 3.16678 13.1949Z",
    fill: "#474747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.104a330d3fbec89467db567ea323c3e7.svg";
export { ForwardRef as ReactComponent };